module.exports = __webpack_public_path__ + "img/twitter.3775d2d9.svg";